(() => {
  const body = document.body;
  const menu = document.getElementById('menu');
  const inEditor = !!(window.Shopify && window.Shopify.designMode);

  // スクロール後：固定ハンバーガーを出す（ワイヤー注記「スクロール後のGnaviはハンバーガーメニュー」）
  const onScroll = () => body.classList.toggle('is-scrolled', window.scrollY > window.innerHeight * 0.6);
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  // 全画面メニュー
  if (menu) {
    let lastFocus = null;
    const openers = () => document.querySelectorAll('.js-menu-open');
    const openMenu = () => {
      lastFocus = document.activeElement;
      body.classList.add('menu-open');
      openers().forEach(b => b.setAttribute('aria-expanded', 'true'));
      menu.querySelector('.js-menu-close').focus();
    };
    const closeMenu = () => {
      body.classList.remove('menu-open');
      openers().forEach(b => b.setAttribute('aria-expanded', 'false'));
      if (lastFocus) lastFocus.focus();
    };
    document.addEventListener('click', e => {
      if (e.target.closest('.js-menu-open')) openMenu();
      else if (e.target.closest('.js-menu-close') || (e.target.closest('#menu a'))) closeMenu();
    });
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && body.classList.contains('menu-open')) closeMenu(); });
  }

  // ページ上部へ
  document.addEventListener('click', e => {
    if (!e.target.closest('.js-to-top')) return;
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });

  // 静かに現れる演出（カスタマイズ画面では最初から表示する）
  const showAll = root => root.querySelectorAll('.reveal').forEach(el => el.classList.add('is-in'));
  if (inEditor || !('IntersectionObserver' in window)) {
    showAll(document);
    document.addEventListener('shopify:section:load', e => showAll(e.target));
    return;
  }
  const io = new IntersectionObserver(entries => {
    entries.forEach(en => {
      if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px' });
  document.querySelectorAll('.reveal').forEach(el => io.observe(el));
})();

/* よくあるご質問：見ているカテゴリのタブを強調・#gift などで来たら最初の質問を開く */
(() => {
  const tabs = document.querySelectorAll('.faq-tabs a');
  if (tabs.length && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver(entries => {
      entries.forEach(en => {
        if (!en.isIntersecting) return;
        tabs.forEach(a => a.classList.toggle('is-on', a.getAttribute('href') === '#' + en.target.id));
      });
    }, { rootMargin: '-35% 0px -60% 0px' });
    tabs.forEach(a => { const g = document.getElementById(a.getAttribute('href').slice(1)); if (g) io.observe(g); });
  }
  const id = decodeURIComponent(location.hash.slice(1));
  const target = id && document.getElementById(id);
  if (target && target.classList.contains('faq-group')) {
    const first = target.querySelector('details');
    if (first) first.open = true;
    requestAnimationFrame(() => target.scrollIntoView({ block: 'start' }));
  }
})();

/* 言語・通貨の切り替え：国を選んだらすぐ切り替える */
document.addEventListener('change', e => {
  const sel = e.target.closest('.js-loc-select');
  if (sel && sel.form) sel.form.submit();
});
